import { captureEvent } from '@sentry/react'

import { axiosBackendInstanceV2 } from '../axiosInstance'
import { ERRORS, LOCAL_STORAGE } from '../constants'

interface RefreshTokenResponse {
  accessToken: string
}

export const useRefreshToken = () => {
  const refresh = async (): Promise<string> => {
    // Use V2 instance which returns the full response for proper typing
    const response = await axiosBackendInstanceV2
      .get<RefreshTokenResponse>('/auth/refresh', {
        withCredentials: true,
      })
      .catch((err) => {
        captureEvent({
          message: ERRORS.TOKEN_REFRESH_ERROR,
          level: 'error',
          extra: {
            err: err.message,
            newToken: response.data.accessToken,
            oldToken: localStorage.getItem(LOCAL_STORAGE.JWT_TOKEN),
          },
        })
        throw new Error(err)
      })

    if (!response.data.accessToken) {
      captureEvent({
        message: ERRORS.TOKEN_REFRESH_ERROR,
        level: 'error',
        extra: { err: 'No access token in response' },
      })
    }

    // TODO: Need to get this out of local storage
    localStorage.setItem(LOCAL_STORAGE.JWT_TOKEN, response.data.accessToken)
    return response.data.accessToken
  }

  return refresh
}
